export default {
  "ko": [
    [
      "예산 모니터링",
      "Budget Monitoring"
    ],
    [
      "근무 시간표",
      "Time Sheet"
    ],
    [
      "급여 명세서",
      "Paystub"
    ],
    [
      "서비스 코드",
      "Service Code"
    ],
    [
      "사회보장번호",
      "Social Security Number"
    ],
    [
      "라우팅 번호",
      "Routing Number"
    ],
    [
      "사회보장카드",
      "Social Security Card"
    ],
    [
      "2단계 인증",
      "Two-Factor Authentication"
    ],
    [
      "메시지 센터",
      "Message Center"
    ],
    [
      "지출 계획",
      "Spending Plan"
    ],
    [
      "승인 예산",
      "Authorized Budget"
    ],
    [
      "클라이언트",
      "Client"
    ],
    [
      "법정대리인",
      "Legal Representative"
    ],
    [
      "무효 수표",
      "Voided Check"
    ],
    [
      "증빙 서류",
      "Supporting Document"
    ],
    [
      "계좌 이체",
      "Direct Deposit"
    ],
    [
      "기기 관리",
      "Device Management"
    ],
    [
      "계정 관리",
      "Account Management"
    ],
    [
      "구매 주문",
      "Purchase Order"
    ],
    [
      "구매 요청",
      "Purchase Request"
    ],
    [
      "이용 안내",
      "Guide"
    ],
    [
      "공급업체",
      "Vendor"
    ],
    [
      "실수령액",
      "Net Pay"
    ],
    [
      "원천징수",
      "Tax Withholding"
    ],
    [
      "개인정보",
      "Personal Information"
    ],
    [
      "대시보드",
      "Dashboard"
    ],
    [
      "청구서",
      "Invoice"
    ],
    [
      "총예산",
      "Total Budget"
    ],
    [
      "공제액",
      "Deductions"
    ],
    [
      "고용주",
      "Employer"
    ],
    [
      "영수증",
      "Receipt"
    ],
    [
      "급여",
      "Payroll"
    ],
    [
      "예산",
      "Budget"
    ],
    [
      "직원",
      "Employee"
    ],
    [
      "요율",
      "Rate"
    ],
    [
      "등록",
      "Enrollment"
    ],
    [
      "승인",
      "Approval"
    ]
  ],
  "es": [
    [
      "autenticación de dos factores",
      "Two-Factor Authentication"
    ],
    [
      "Seguimiento del presupuesto",
      "Budget Monitoring"
    ],
    [
      "número de ruta bancaria",
      "Routing Number"
    ],
    [
      "Gestión de dispositivos",
      "Device Management"
    ],
    [
      "presupuesto autorizado",
      "Authorized Budget"
    ],
    [
      "retención de impuestos",
      "Tax Withholding"
    ],
    [
      "Gestión de la cuenta",
      "Account Management"
    ],
    [
      "Información personal",
      "Personal Information"
    ],
    [
      "representante legal",
      "Legal Representative"
    ],
    [
      "solicitud de compra",
      "Purchase Request"
    ],
    [
      "código de servicio",
      "Service Code"
    ],
    [
      "Centro de mensajes",
      "Message Center"
    ],
    [
      "depósito directo",
      "Direct Deposit"
    ],
    [
      "Orden de compra",
      "Purchase Order"
    ],
    [
      "Panel de inicio",
      "Dashboard"
    ],
    [
      "hojas de horas",
      "Time Sheets"
    ],
    [
      "plan de gastos",
      "Spending Plan"
    ],
    [
      "cheque anulado",
      "Voided Check"
    ],
    [
      "hoja de horas",
      "Time Sheet"
    ],
    [
      "Seguro Social",
      "Social Security"
    ],
    [
      "presupuesto",
      "Budget"
    ],
    [
      "proveedores",
      "Vendors"
    ],
    [
      "deducciones",
      "Deductions"
    ],
    [
      "Inscripción",
      "Enrollment"
    ],
    [
      "aprobación",
      "Approval"
    ],
    [
      "proveedor",
      "Vendor"
    ],
    [
      "empleados",
      "Employees"
    ],
    [
      "pago neto",
      "Net Pay"
    ],
    [
      "empleador",
      "Employer"
    ],
    [
      "facturas",
      "Invoices"
    ],
    [
      "clientes",
      "Clients"
    ],
    [
      "empleado",
      "Employee"
    ],
    [
      "factura",
      "Invoice"
    ],
    [
      "cliente",
      "Client"
    ],
    [
      "nómina",
      "Payroll"
    ],
    [
      "tarifa",
      "Rate"
    ],
    [
      "recibo",
      "Receipt"
    ],
    [
      "Guía",
      "Guide"
    ]
  ]
};
